// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "home" + "." + "525cb61bbe8c08a47555" + ".css";
};